// de.js
// German translations for react-intl


/* eslint-disable */
export default {
  dashboard: "Dashboard",
  templates: "Vorlagen",
  workflow: "Workflow",
  content: "Inhalt",
  company: "Unternehmen",
  Communication: "Kommunikation",
  Staff: "Mitarbeiter",
  created_at: "Erstellungsdatum",
  Checklist: "Checkliste",
  Settings: "Einstellungen",
  activity_log: "Aktivitätsprotokoll",
  name: "Name",
  staff_mang: "Mitarbeiterverwaltung",
  Edit_btn: "Bearbeiten",
  create_staff: "Mitarbeiter erstellen",
  update_staff: "Mitarbeiter bearbeiten",
  delete: "Löschen",
  edit: "Bearbeiten",
  create: "Erstellen",
  update: "Aktualisieren",
  cancel: "Abbrechen",
  role: "Rolle",
  plce_role: "Bitte Rolle eingeben",
  role_rule: "Bitte Rolle auswählen",
  action: "Aktion",
  phone_no: "Telefon",
  phone_rule: "Bitte eine gültige Telefonnummer eingeben",
  plce_phoneno: "Telefonnummer eingeben",
  email: "E-Mail",
  plce_email: "E-Mail eingeben",
  email_rule: "Bitte E-Mail eingeben",
  lastname: "Nachname",
  lname_rule: "Bitte Nachnamen eingeben",
  plce_lastname: "Nachnamen eingeben",
  plce_firstname: "Vornamen eingeben",
  fname_rule: "Bitte Vornamen eingeben",
  firstname: "Vorname",
  Create_temp: "Vorlage erstellen",
  update_temp: "Vorlage aktualisieren",
  active: "Aktiv",
  inactive: "Inaktiv",
  submit: "Absenden",
  approvars: "Genehmiger",
  addnew: "Neu hinzufügen",
  view: "Ansehen",
  title: "Titel",
  single: "Einzeln",
  multiple: "Mehrfach",
  inp_type: "Eingabetyp",
  grid_type: "Grid-Typ",
  selec_type: "Ansichtstyp auswählen",
  placeholder: "Platzhalter",
  plce_grid: "Grid-Typ auswählen",
  plce_type: "Eingabetyp auswählen",
  plce_title: "Titel eingeben",
  ent_plce: "Platzhalter eingeben",
  rule_grid: "Bitte Grid-Typ auswählen!",
  rule_type: "Bitte Vorlagentyp auswählen!",
  rule_title: "Bitte Titel eingeben",
  options: "Optionen",
  Add_field: "Feld hinzufügen",
  options_rule: "Bitte Optionsnamen eingeben",
  option_name: "Optionsnamen eingeben",
  val_type: "Werttyp",
  ent_info: "Info eingeben",
  ent_label: "Beschriftung eingeben",
  ent_field: "Feldnamen eingeben",
  info: "Info",
  required: "Erforderlich",
  add_attribute: "Attribut hinzufügen",
  create_workflow: "Workflow erstellen",
  workflow_name: "Name",
  workflow_type: "Typ",
  description: "Beschreibung",
  checklist: "Checkliste",
  company_rule: "Bitte einen Unternehmensnamen eingeben",
  select: "Auswählen",
  plce_company: "Unternehmensnamen auswählen",
  desc_rule: "Bitte eine Beschreibung eingeben",
  workflow_type_rule: "Bitte Workflow-Typ auswählen",
  workflow_rule: "Workflow-Typ auswählen",
  plce_workflow: "Workflownamen eingeben",
  plce_workflow_type: "Workflow-Typ eingeben",
  plce_checklist: "Checkliste auswählen",
  create_work: "Zum Workflow erstellen",
  con_Content: "Vertragsinhalt",
  create_content: "Inhalt erstellen",
  update_content: "Inhalt aktualisieren",
  content_name: "Inhaltsname",
  content_type: "Inhaltstyp",
  plce_content_type: "Typ eingeben",
  content_type_rule: "Bitte einen Inhaltstyp eingeben",
  content_name_rule: "Bitte einen Inhaltsnamen eingeben",
  plce_content_name: "Name eingeben",
  content_rule: "Bitte einen Inhalt eingeben",
  plce_content: "Inhalt eingeben",
  create_company: "Unternehmen erstellen",
  company_name: "Unternehmensname",
  address: "Adresse",
  pincode: "Postleitzahl",
  categoryId: "Kategorie-ID",
  update_company: "Unternehmen aktualisieren",
  cname_rule: "Bitte einen Unternehmensnamen eingeben",
  cname_placeholder: "Unternehmensname eingeben",
  address_rule: "Bitte eine Unternehmensadresse eingeben",
  plce_address: "Adresse eingeben",
  plce_pincode: "Postleitzahl eingeben",
  pincode_rule: "Bitte eine Postleitzahl eingeben",
  workflow_Services: "Workflow-Services",
  template_Services: "Vorlagen-Services",
  content_Services: "Inhalts-Services",
  workflowtype_Services: "Workflowtyp-Services",
  option_rule: "Option erforderlich",
  category_name: "Kategoriename",
  create_category: "Kategorie erstellen",
  update_category: "Kategorie aktualisieren",
  categoryname: "Kategoriename",
  category_rule: "Bitte einen Kategorienamen eingeben",
  rule_description: "Bitte eine Beschreibung eingeben",
  plce_description: "Beschreibung eingeben",
  category: "Kategorie",
  plce_category: "Kategorie eingeben",
  create_checklist: "Checkliste erstellen",
  update_checklist: "Checkliste aktualisieren",
  checklist_name: "Checklistenname",
  contentType: "Inhaltstyp",
  contractType: "Vertragstyp",
  contentType_rule: "Bitte einen Inhaltstyp eingeben.",
  contractType_rule: "Bitte einen Vertragstyp eingeben.",
  plce_contentType: "Inhaltstyp eingeben",
  plce_contractType: "Vertragstyp eingeben",
  create_contentType: "Vertragstyp erstellen",
  update_contentType: "Vertragstyp aktualisieren",
  selecttemp: "Vorlage auswählen",
  selectcontent: "Inhalt auswählen",
  close: "Schließen",
  create_Approval: "Genehmigung erstellen",
  add_approval: "Genehmigung hinzufügen",
  levelname: "Stufenname",
  strategy: "Strategie",
  update_workflow: "Workflow aktualisieren",
  update_password: "Passwort aktualisieren",
  enter_comment: "Kommentar eingeben",
  Template: "Vorlage",
  template: "Vorlagen",

  levelname_rule: "Bitte Stufennamen eingeben",
  plce_levelname: "Stufennamen eingeben",
  workflow_typename: "Workflowtyp-Name",
  workflow_type_delete: "Möchten Sie diesen Workflowtyp wirklich löschen?",
  yes: "Ja",
  no: "Nein",
  change: "Ändern",
  create_workflow_type: "Workflowtyp erstellen",
  update_workflow_type: "Workflowtyp aktualisieren",
  workflow_type_name: "Workflowtyp-Name",
  workflowtype_rule: "Bitte einen Workflowtyp-Namen eingeben",
  plce_workflowtype: "Bitte Workflownamen eingeben",
  TimelineComment: "Zeitleiste/Kommentar",
  please_select_template: "Bitte Vorlage auswählen",
  please_select_content: "Bitte Inhalt auswählen",
  please_select_checklist: "Bitte Checkliste auswählen",
  approval: "Genehmigung",
  profile: "Profil",
  resetpassword: "Passwort zurücksetzen",
  reset: "Zurücksetzen",
  Userdetails: "Benutzerdaten",
  updatepassword: "Passwort aktualisieren",
  vendor: "Lieferant",
  vendors: "Lieferanten",
  vendor_mang: "Lieferantenverwaltung",
  create_vendor: "Lieferant erstellen",
  firstName: "Vorname",
  lastName: "Nachname",
  save: "Speichern",
  phoneno: "Telefon",
  gender: "Geschlecht",
  update_vendor: "Lieferant aktualisieren",
  agrrement_management: "Vertragsverwaltung",
  refresh: "Aktualisieren",
  task_management: "Aufgabenverwaltung",
  create_task: "Aufgabe erstellen",
  update_task: "Aufgabe aktualisieren",
  task: "Aufgabe",
  taskname: "Aufgabenname",
  startdate: "Startdatum",
  enddate: "Enddatum",
  taskname_rule: "Bitte einen Aufgabennamen eingeben",
  plce_taskname: "Aufgabenname eingeben",
  plce_enddate: "Enddatum auswählen",
  enddate_rule: "Bitte Enddatum auswählen",
  plce_startdate: "Startdatum auswählen",
  startdate_rule: "Bitte Startdatum auswählen",
  task_details: "Aufgabendetails",
  company_delete_title: "Möchten Sie dieses Unternehmen wirklich löschen?",
  content_delete_title: "Möchten Sie diesen Inhalt wirklich löschen?",
  field_delete_title: "Möchten Sie dieses Feld wirklich löschen?",

  contenttype_delete_titte: "Möchten Sie diesen Inhaltstyp wirklich löschen?",
  category_delete_title: "Möchten Sie diese Kategorie wirklich löschen?",
  vendor_delete_title: "Möchten Sie diesen Lieferanten wirklich löschen?",
  task_delete_title: "Möchten Sie diese Aufgabe wirklich löschen?",
  approval_delete_title: "Möchten Sie diese Genehmigung wirklich löschen?",
  checklist_delete_titte: "Möchten Sie diese Checkliste wirklich löschen?",
  search_: "Suchen...",
  new_password: "Neues Passwort",
  new_password_rule: "Bitte neues Passwort eingeben!",
  new_password_plce: "Neues Passwort eingeben",
  confirm_password_plce: "Passwort bestätigen",
  confirm_password_rule: "Bitte Passwort bestätigen!",
  password_not_match: "Die eingegebenen Passwörter stimmen nicht überein!",
  confirm_password: "Passwort bestätigen",
  company_details: "Unternehmensdetails",
  workflow_delete_title: "Möchten Sie diesen Workflow wirklich löschen?",
  staff_delete_title: "Möchten Sie diesen Mitarbeiter wirklich löschen?",
  staff_delete_title_contract: "Möchten Sie diesen Vertrag wirklich löschen?",
  template_delete_title: "Möchten Sie diese Vorlage wirklich löschen?",
  WorkflowType: "Workflowtyp",
  comments: "Kommentare",
  detailview: "Detailansicht",
  task_name: "Aufgabenname",
  status: "Status",
  task_template_name: "Name der Aufgabenvorlage",
  Select_vendor: "Lieferant auswählen",
  please_select_vendor: "Bitte Lieferanten auswählen",
  please_select_staff: "Bitte Mitarbeiter auswählen",
  forgot_password: "Passwort vergessen",
  data_not_found: "Keine Daten gefunden",
  new_password_rules: "Passwort muss 6–16 Zeichen lang sein",
  new_password_patternrules: "Ihr Passwort muss Groß- und Kleinbuchstaben, mindestens eine Zahl und ein Sonderzeichen enthalten und zwischen 8 und 16 Zeichen lang sein. Bitte erneut versuchen.",
  new_password_patternrules_new: "Ihr Passwort muss Groß- und Kleinbuchstaben, mindestens eine Zahl und ein Sonderzeichen enthalten und zwischen 8 und 16 Zeichen lang sein. Bitte erneut versuchen.",
  confirm_password_checkrule: "Passwörter stimmen nicht überein, bitte erneut eingeben",
  edit_comment: "Kommentar bearbeiten",
  rule_label: "Bitte Beschriftung eingeben",
  rule_datatype: "Bitte Datentyp auswählen",
  company_owner_detail: "Unternehmenseigentümer-Details",
  Enter_Comment_here: "Kommentar hier eingeben",

  pleaseEnterComment: "Bitte Kommentar eingeben",
  today: "Heute",
  tomorrow: "Morgen",
  yesterday: "Gestern",
  edit_content: "Inhalt bearbeiten",
  edit_template: "Vorlage bearbeiten",
  basic_details: "Grunddaten",
  fields_details: "Felddetails",
  next: "Weiter",
  previous: "Zurück",
  Accept: "Akzeptieren",
  rule_category: "Bitte Kategorie auswählen",
  login: "Anmelden",
  forget_your_password: "Passwort vergessen?",
  password: "Passwort",
  password_rule: "Bitte Passwort eingeben!",
  useremail_rule: "Bitte Benutzer-E-Mail eingeben!",
  useremail: "Benutzer-E-Mail",
  plce_workflow_task: "Workflow-Typ auswählen",
  noDataFound: "Keine Daten gefunden",
  wait: "Warten",
  no_record_found: "Kein Eintrag gefunden",
  workflow_management: "Workflowverwaltung",
  logout: "Abmelden",
  super_admin: "Super-Admin",
  step: "Schritt",
  step_1: "Schritt 1",
  step_2: "Schritt 2",
  step_3: "Schritt 3",
  input_comment_rule: "Bitte Kommentar eingeben",
  select_all: "Alle auswählen",
  checklist_detail: "Checklisten-Details",
  content_detail: "Inhaltsdetails",
  template_detail: "Vorlagendetails",
  approval_detail: "Genehmigungsdetails",
  changepassword: "Passwort ändern",
  plce_strategy: "Strategie auswählen",
  please_strategy: "Bitte Strategie auswählen",
  level: "Stufe",
  reject: "Ablehnen",
  task_managementVendor: "Aufgabenverwaltung Lieferant",
  selectchecklist: "Checkliste auswählen",
  Otp: "OTP",
  otp_rule: "OTP eingeben",
  new_otp_plce: "OTP eingeben",
  plce_select_company: "Unternehmen auswählen",
  workflow_approve_title: "Workflow genehmigen?",
  approve: "Genehmigen",
  Content_Checklist: "Inhalts-Checkliste",
  content_selection: "Inhaltsauswahl",
  workflow_accept_title: "Workflow akzeptieren?",
  type: "Typ",
  pending: "Ausstehend",
  progress: "In Bearbeitung",
  completed: "Abgeschlossen",

  signature_required: "Signatur erforderlich",
  checklist_item: "Checklistenpunkt",
  parameterized: "Parametrisiert",
  assign: "Zuweisen",
  assign_workflow: "Workflow zuweisen",
  mycontract: "Meine Verträge",
  kyc: "KYC",
  created_by: "Erstellt von",
  download: "Herunterladen",
  email_valid_rule: "Gültige E-Mail eingeben",
  comment: "Kommentar",
  total: "Summe",
  created_content: "Erstellte Inhalte",
  approve_content: "Inhalte genehmigen",
  created_workflow: "Erstellte Workflows",
  assigned_workflow: "Zugewiesene Workflows",
  approvedWorkflow: "Genehmigte Workflows",
  inprogress: "In Bearbeitung",
  pendingtasks: "Ausstehende Aufgabe",
  total_template: "Vorlagen gesamt",
  total_content: "Inhalte gesamt",
  total_workflow: "Workflows gesamt",
  total_task: "Aufgaben gesamt",
  task_detail: "Aufgabendetails",
  workflow_detail: "Workflowdetails",
  content_details: "Inhaltsdetails",
  email_must_rule: "Bitte E-Mail eingeben",
  Template_Fields: "Vorlagenfelder",
  clear: "Leeren",
  total_company: "Unternehmen gesamt",
  accepted_content: "Akzeptierte Inhalte",
  rejection_comment: "Ablehnungsgrund",
  contractexpiry: "Vertragsablauf",
  rule_contractexpiry: "Bitte Vertragsablauf eingeben",
  type_of_input: "Eingabetyp",
  type_your_signature: "Signatur eingeben",
  default_fields: "Standardfelder",
  enterdigit: "Ziffer eingeben",
  please_select: "Bitte eine Option auswählen",
  default_field: "Standardfelder",
  key: "Schlüssel",
  sample_content: "Beispielinhalt",
  create_SampleContent: "Beispielinhalt erstellen",
  content_title: "Titel",
  update_SampleContent: "Beispielinhalt aktualisieren",
  notification: "Benachrichtigung",
  plce_select_sample: "Beispiel auswählen",
  review_comment: "Review-Kommentare",
  expire_on: "Läuft ab am",
  my_contracts: "Meine Verträge",
  my_task: "Meine Aufgabe",
  staff: "Mitarbeiter",
  Select_staff: "Mitarbeiter auswählen",
  Activation_date: "Aktivierungsdatum",
  expire_date: "Ablaufdatum",
  create_new: "Neu erstellen",
  workflow_popupconfirm_title: "Möchten Sie den Workflow wirklich absenden?",
  taskname_contractname: "Name",
  designation: "Position",
  designation_placeholder: "Position eingeben",
  contract: "Vertrag",
  create_template: "Vorlage erstellen",
  create_date: "Erstellungsdatum",
  filter: "Filter",
  content_no: "Inhalts-Nr.",
  template_no: "Vorlagen-Nr.",
  workflow_no: "Workflow-Nr.",
  popup: "Popup",
  total_templates: "Vorlage(n)",
  total_contents: "Inhalt(e)",
  total_workflows: "Workflows",
  total_companys: "Unternehmen",
  content_types: "Inhaltstyp",
  total_tasks: "Aufgabe(n)",
  assigned_company: "Zugewiesene Unternehmen",
  fill_vendor_detail: "Lieferantendaten ausfüllen",
  workflow_reject_title: "Workflow ablehnen",
  Assign_vendors: "Zugewiesene Lieferanten",
  vendor_details: "Lieferantendetail",
  other_Services: "Weitere Services",
  preference: "Präferenz",
  companyName: "Firmenname",
  Task_popupconfirm_title: "Möchten Sie wirklich genehmigen?",
  ApprovedTask: "Genehmigt",
  signInProgress: "Signatur in Bearbeitung",
  company_content: "Inhalte des Unternehmens",
  open: "Offen",
  expired: "Abgelaufen",
  enable: "Aktivieren",
  disable: "Deaktivieren",
  inactive: "Inaktiv",
  active_confirm_title: "Möchten Sie dieses Unternehmen wirklich aktivieren?",
  inactive_confirm_title: "Möchten Sie dieses Unternehmen wirklich deaktivieren?",
  enable_confirm_title: "Möchten Sie die Lizenz dieses Unternehmens wirklich aktivieren?",
  disable_confirm_title: "Möchten Sie die Lizenz dieses Unternehmens wirklich deaktivieren?",
  task_datasubmit_title: "Sind Ihr Wirksamkeitsdatum und Ausführungsdatum gleich?",
  renew_task_datasubmit_title: "Ist Ihr Wirksamkeitsdatum gleich dem Ablaufdatum des ursprünglichen Vertrags?",
  task_datasubmit_execution_title: "Ihr Wirksamkeitsdatum entspricht dem Ausführungsdatum",
  renew_task_datasubmit_execution_title: "Ihr Wirksamkeitsdatum entspricht dem Ablaufdatum des ursprünglichen Vertrags",
  content_validation: "Sie haben einige Felder der Vorlage nicht verwendet. Inhalt trotzdem absenden?",
  task_datasubmit_executionafter_title: "Ihr Wirksamkeitsdatum ist",
  import: "Importieren",
  create_bulk_task: "Sammelaufgabe erstellen",
  sample_excel_file: "Beispiel-Excel-Datei",
  file: "Datei",
  import_SampleContent: "Beispielinhalt importieren",
  import_contentType: "Vertragstyp importieren",
  import_category: "Kategorie importieren",
  import_workflow_type: "Workflowtyp importieren",
  import_checklist: "Checkliste importieren",
  Ok: "OK",
  enable_licence: "Lizenz aktivieren",
  disable_licence: "Lizenz deaktivieren",
  activate: "Aktivieren",
  deactivate: "Deaktivieren",
  start_date: "Startdatum",
  end_date: "Enddatum",
  effective_date: "Wirksamkeitsdatum",
  execution_date: "Ausführungsdatum",
  contract_expiry: "Vertragsablauf",
  phone_number: "Telefonnummer",
  dob: "Geburtsdatum",
  age: "Alter",
  Workflow_key: "Workflow-Schlüssel",
  effective_execution_date_same: "Wirksamkeits- und Ausführungsdatum identisch",
  level_1: "Stufe 1",
  task_start_date: "Aufgabenstartdatum",
  task_end_date: "Aufgabenenddatum",
  secretAccessKey: "Geheimer Zugriffsschlüssel",
  keyId: "Schlüssel-ID",
  storageType: "Speichertyp",
  Select_Email: "E-Mail auswählen",
  premium_features: "Premium-Funktionen",
  company_premium_features: "Unternehmens-Premiumfunktionen",
  bulk_task: "Sammelaufgabe",
  awsBucketRegion: "AWS-Bucket-Region",
  awsBucketName: "AWS-Bucket-Name",
  storagetype_confirm_title: "Ab jetzt werden Ihre Daten im angegebenen Bucket gespeichert",
  tlp_storageType: "Speichertyp auswählen",
  tlp_key_id: "Die AWS Key ID ist ein eindeutiger Bezeichner für den Zugriff auf Ihren Speicher in AWS. Sie erhalten ihn im AWS-Konto-Dashboard.",
  tlp_secretAccessKey: "Der AWS Secret Access Key ist ein vertraulicher Schlüssel zur Authentifizierung und zum Zugriff auf Ihren AWS-Speicher. Bewahren Sie ihn sicher auf und teilen Sie ihn nicht.",
  tlp_awsBucketName: "Der AWS Bucket Name ist der eindeutige Name Ihres Speichers in AWS. Er dient zur Identifizierung und zum Zugriff auf den entsprechenden Bucket.",
  tlp_awsBucketRegion: "Die AWS Bucket Region ist die geografische Region Ihres Buckets. Sie bestimmt den physischen Speicherort Ihrer Daten.",
  user_details: "Benutzerdaten",
  access_key_id: "Zugriffsschlüssel-ID",
  upload_request: "Upload-Anfrage",
  change_request: "Änderungsanfrage",
  update_request: "Aktualisierungsanfrage",
  changes_history: "Änderungshistorie",
  template_history: "Vorlagenhistorie",
  history: "Historie",
  upload_request_title: "Was möchten Sie ändern?",
  content_: "Inhalt",
  changes: "Änderungen",
  review_changes: "Änderungen prüfen",
  historical_contract: "Historische Verträge",
  create_historical_contract: "Historischen Vertrag erstellen",
  update_historical_contract: "Historischen Vertrag aktualisieren",
  contract_name: "Vertragsname",
  contract_type: "Vertragstyp",
  parties_name: "Parteiname",
  parties_address: "Parteianschrift",
  expiry_date: "Ablaufdatum",
  form_name: "Formularname",
  form_type: "Zusatzfeld-Typ",
  select_form_type: "Zusatzfeld-Typ auswählen",
  plce_contract_name: "Vertragsname eingeben",
  plce_parties_name: "Parteinamen eingeben",
  plce_parties_desc: "Parteibeschreibung eingeben",
  plce_form_name: "Formularnamen eingeben",
  select_contract_type: "Vertragstyp auswählen",
  details: "Details",
  preview: "Vorschau",
  noDataMsg: "Keine Daten",
  extra_details: "Zusätzliche Details",
  comments_activity: "Kommentare/Aktivitäten",
  no_contracts: "Keine Verträge",
  Inprogress: "In Bearbeitung",
  historical_Services: "Historische Services",
  Template_details: "Vorlagendetails",
  activities: "Aktivitäten",
  company_signatory: "Unternehmensunterzeichner",
  parties: "Parteien",
  abort: "Abbrechen",
  re_open: "Wieder öffnen",
  nickName: "Spitzname",
  nickName_rule: "Bitte Spitznamen eingeben",
  registeredAddress: "Eingetragene Adresse",
  plce_nickName: "Spitznamen eingeben",
  plce_registeredAddress: "Eingetragene Adresse eingeben",
  registeredAddress_rule: "Bitte eingetragene Adresse eingeben",
  content_types_contract_type: "Vertragstyp",
  verify_contract: "Vertrag prüfen",
  relation_list: "Beziehungsliste",
  create_relation_list: "Beziehungsformular erstellen",
  relation_form: "Beziehungsformular",
  nickname_same_as_above_name: "Spitzname wie oben?",
  registerd_address_same_as_above: "Eingetr. Adresse wie oben?",
  terminate: "Beenden",
  addendum: "Nachtrag",
  create_addendum: "Nachtrag erstellen",
  fill_template: "Vorlage ausfüllen",
  addendumName: "Name",
  renew_contract: "Vertrag verlängern",
  Default_View: "Standardansicht",
  grid_view: "Rasteransicht", 
  vendor_view: "Lieferantenansicht",
  my_contract: "Mein Vertrag",
  contract_details: "Vertragsdetails",
  reviewer: "Prüfer",
  vendor_name: "Lieferantenname",
  parent_contract_name: "Name des Ausgangsvertrags",
  review: "Prüfung",
  add_review: "Prüfung hinzufügen",
  review_comp: "Prüfung abschließen",
  draft: "Entwurf",
  in_progress: "In Bearbeitung",
  userName: "Benutzername",
  GDD: "Google-Drive-Details",
  reviewer_name: "Prüfername",
  address1: "Adresse1",
  address2: "Adresse2",
  country: "Land",
  country_rule: "Land auswählen",
  plce_country: "Bitte Land auswählen",
  state: "Bundesland",
  select_state: "Bundesland auswählen",
  plce_state: "Bitte Bundesland auswählen",
  city: "Stadt",
  select_city: "Stadt auswählen",
  plce_city: "Bitte Stadt auswählen",
  version: "Version",
  please_select_version: "Bitte Version auswählen",
  Select_version: "Version auswählen",
  version_preview: "Versionsvorschau",
  storageType_rule: "Bitte Speichertyp auswählen",
  content_req_change: "Angeforderte Inhaltsänderungen",
  comment_list: "Kommentar-Liste",
  timeZone: "Zeitzone",
  verify: "Prüfen",
  timeZone_rule: "Bitte Zeitzone auswählen",
  plce_country_timezone: "Zeitzone auswählen",
  connect_to: "Verbinden mit",
  reconnect_to: "Verbinden",
  ok: "OK",
  reasonArr: "Fehler",
  confirm_content: "Inhalt bestätigen",
  address_2: "Adresszeile 2",
  contract_verification: "Benötigen Sie eine Vertragsprüfung?",
  contract_count: "Benötigen Sie eine Vertragsanzahl?",
  setcontract_count: "Vertragslimit eingeben",
  content_count: "Benötigen Sie eine Inhaltsanzahl?",
  setcontent_count: "Inhaltslimit eingeben",
  contentLibrary_count: "Benötigen Sie eine Content-Library-Anzahl?",
  setcontentLibrary_count: "Content-Library-Limit eingeben",
  select_storages: "Speicher auswählen",
  select_contract_limit: "Ist der Vertrag begrenzt?",
  sethistorical_count: "Limit historischer Verträge eingeben",
  select_historicalcontract_limit: "Sind historische Verträge begrenzt?",
  hiscontract_count: "Benötigen Sie eine Anzahl historischer Verträge?",
  staff_count_limit: "Benötigen Sie begrenzte Prüfer?",
  template_count_limit: "Benötigen Sie begrenzte Vorlagen?",
  workflow_count_limit: "Benötigen Sie begrenzte Workflows?",
  vendor_count_limit: "Benötigen Sie begrenzte Lieferanten?",
  signatory_count_limit: "Benötigen Sie begrenzte Unterzeichner?",

  settemplate_count_: "Vorlagenlimit eingeben",
  setvendor_count_: "Lieferantenlimit eingeben",
  setworkflow_count_: "Workflowlimit eingeben",
  setsignatory_count_: "Unterzeichnerlimit eingeben",
  select_staffcount_limit: "Sind Prüfer begrenzt?",
  setstaff_count_: "Prüferlimit eingeben",
  resend_code: "Code erneut senden",
  otp_required: "OTP ist erforderlich",
  otp_description: "Bitte den Bestätigungscode eingeben, der an Ihre E-Mail-Adresse gesendet wurde",
  is_guest_user: "Als Gast anmelden",
  License: "Lizenz",
  licence_name: "Planname",
  licensing_features: "Lizenzfunktionen",
  planpackages: "Pläne",
  no_list: "Keine Liste",
  plans: "Mein Plan",
  termination_date: "Kündigungsdatum",
  execution_status: "Ausführungsstatus",
  plce_parties_add: "Kundenadresse",
  cp_address: "Adresse der Gegenpartei",
  cp_name: "Name der Gegenpartei",
  cp_detail: "Details der Gegenpartei",
  your_role: "Ihre Rolle",
  cp_business_type: "Geschäftsart der Gegenpartei",
  client_name: "Kundenname",
  client_address: "Kundenadresse",
  extra_delete_titte: "Möchten Sie dieses Zusatzformular wirklich löschen?",
  guest_user: "Gastbenutzer",
  last7Days: "Letzte 7 Tage",
  last30Days: "Letzte 30 Tage",
  currentMonth: "Aktueller Monat",
  lastMonth: "Letzter Monat",
  last3Months: "Letzte 3 Monate",
  last6Months: "Letzte 6 Monate",
  Oneyear: "Letztes Jahr",
  obligation: "Verpflichtung",
  create_obligation: "Verpflichtung erstellen",
  myobligation: "Meine Verpflichtung",
  step_4: "Schritt 4",
  assign_to: "Zuweisen an",
  slaType: "SLA",
  update_obligation: "Verpflichtung aktualisieren",
  adobe: "Adobe",
  signature: "Signatur",
  select_signatures: "Signatur auswählen",
  obligation_Services: "Verpflichtungs-Services",
  onbgname_rule: "Bitte Verpflichtungsnamen eingeben",
  slatype_type_rule: "Bitte Service-Level-Agreement auswählen",
  please_select_obligationForm: "Bitte Verpflichtungsformular auswählen",
  create_obligation_form: "Verpflichtungsformular erstellen",
  attachment_rule: "Bitte Anhang hinzufügen",
  accept: "Akzeptieren",
  frequency_type_rule: "Häufigkeit auswählen",
  staff_assignee: "Zugewiesener Mitarbeiter",
  please_add_reject_comment: "Bitte Kommentar hinzufügen",
  please_add_reject_comment_empty: "Kommentar darf nicht leer sein",
  Contractclause: "Vertragsklausel",
  add_rejection_comment: "Kommentar hinzufügen",
  obligation_delete_title_workflow: "Möchten Sie diese Verpflichtung wirklich löschen?",
  frequency: "Häufigkeit",
  obligation_delete_title: "Möchten Sie diese Verpflichtung wirklich löschen?",
  obligationform_delete_titte: "Möchten Sie dieses Verpflichtungsformular wirklich löschen?",
  activity: "Aktivität",
  department: "Abteilung",
  plz_select_dept: "Bitte Abteilung auswählen",
  select_dept: "Abteilung auswählen",
  enter_limit: "Limit eingeben",
  phone_limit: "Bitte ein gültiges Limit eingeben",
  financial_limit: "Finanzlimit-Symbol",
  chat: "Chat",
  plan_delete_title: "Möchten Sie diesen Plan wirklich löschen?",
  content_lib: "Inhaltsbibliothek",
  import_content: "Inhalt importieren",
  pick_content_from: "Inhalt aus Bibliothek auswählen",
  Docusign: "DocuSign",
  Reviewer_title_req: "Wie viele interne Prüfer sind erforderlich?",
  approval_title_req: "Wie viele Unterzeichner sind erforderlich?",
  renewalName: "Name der Verlängerung",
  task_id: "Aufgaben-ID",
  cname_emptyrule: "Firmenname darf nicht leer sein",
  email_emptyrule: "E-Mail darf nicht leer sein",
  designation_emptyrule: "Positionsbezeichnung darf nicht leer sein",
  firstname_emptyrule: "Vorname darf nicht leer sein",
  lastname_emptyrule: "Nachname darf nicht leer sein",
  registeredAddress_emptyrule: "Adresse darf nicht leer sein",
  nickName_emptyrule: "Spitzname darf nicht leer sein",
  obligations: "Verpflichtungen",
  date: "Datum",
  task_no: "Aufgaben-Nr.",
  plce_select_content_type: "Typ auswählen",
  please_content_type_rule: "Bitte Inhaltstyp auswählen",
  id: "Kennung",
  contract_no: "Vertrags-Nr.",
  sign_delete_title: "Möchten Sie die Signatur wirklich löschen?",
  googledrive_delete_confirm_title: "Google-Speicher wirklich entfernen? Ab jetzt werden Ihre Verträge im Standardspeicher gespeichert.",
  clause_lib: "Klauselbibliothek",
  create_clause: "Klausel erstellen",
  update_clause: "Klausel aktualisieren",
  clause: "Klausel",
  last_modified: "Zuletzt geändert",
  plce_clauseDescription: "Klauseltyp beschreiben",
  plce_clauseName: "Benennen Sie den Klauseltyp, z. B. Änderung, Mediation usw.",
  clause_delete_title: "Möchten Sie diese Klausel wirklich löschen?",
  fields: "Felder",
  clauseDescription_rule: "Bitte Klausel beschreiben",
  clauseName_rule: "Bitte Klauselnamen eingeben",
  forgot_password_: "Passwort vergessen",
  request: "Anfrage(n)",
  signout: "Abmelden",
  Contact_sales: "Vertrieb kontaktieren",
  all: "Alle",
  unread: "Ungelesen",
  contractType: "Vertragstyp",
  create_contractType: "Vertragstyp erstellen",
  express_contract: "Expressvertrag",
  datamanager: "Datenmanager",
  display_name: "Anzeigename",
  datatype: "Datentyp",
  unassign_delete_title: "Möchten Sie diesen Vertrag wirklich die Zuordnung aufheben?",
  bulk_assign_modal_title: "Sammelzuweisung an juristische Mitarbeiter",
  delete_duplicates: "Duplikate löschen",
  delete_duplicate: "Duplikat löschen",
  counterparty: "Gegenpartei",
  import_addendum: "Nachtrag importieren",
  contract_admin: "Vertragsadministrator",
  user_admin:"Benutzeradministrator",
  welcome: "Willkommen",
  setting: "Einstellung",
  help: "Hilfe",
  companyPlansHeading: 'Plandetails :-',
  companyPlansBasic: 'Basis',
  companyPlansExpiresOn: 'Läuft ab am:-',

  // Individual item labels (singular)
  companyPlansContent: 'Inhalt',
  companyPlansContents: 'Inhalte',
  companyPlansContentInLibrary: 'Inhalt In Bibliothek',
  companyPlansContentsInLibrary: 'Inhalte In Bibliothek',
  companyPlansWorkflow: 'Arbeitsablauf',
  companyPlansWorkflows: 'Arbeitsabläufe',
  companyPlansContract: 'Vertrag',
  companyPlansContracts: 'Verträge',
  companyPlansHistoricalContract: 'historischer Vertrag',
  companyPlansHistoricalContracts: 'historische Verträge',
  companyPlansReviewer: 'Prüfer',
  companyPlansReviewers: 'Prüfer',
  companyPlansVendor: 'Anbieter',
  companyPlansVendors: 'Anbieter',
  companyPlansSignatory: 'Unterzeichner',
  companyPlansSignatories: 'Unterzeichner',

  // Unlimited labels
  companyPlansUnlimitedContents: 'Unbegrenzte Inhalte',
  companyPlansUnlimitedContentsLibrary: 'Unbegrenzte Inhalte In Bibliothek',
  companyPlansUnlimitedWorkflow: 'Unbegrenzter Arbeitsablauf',
  companyPlansUnlimitedContracts: 'Unbegrenzte Verträge',
  companyPlansUnlimitedHistoricalContracts: 'Unbegrenzte Historische Verträge',
  companyPlansUnlimitedReviewers: 'Unbegrenzte Prüfer',
  companyPlansUnlimitedVendors: 'Unbegrenzte Anbieter',
  companyPlansUnlimitedSignatories: 'Unbegrenzte Unterzeichner',

  // Upto labels with dynamic values
  companyPlansUptoContent: 'Bis zu {count} {type}',
  companyPlansUptoContentLibrary: 'Bis zu {count} {type}',
  companyPlansUptoWorkflow: 'Bis zu {count} {type}',
  companyPlansUptoContracts: 'Bis zu {count} {type}',
  companyPlansUptoHistoricalContracts: 'Bis zu {count} {type}',
  companyPlansUptoReviewers: 'Bis zu {count} {type}',
  companyPlansUptoVendors: 'Bis zu {count} {type}',
  companyPlansUptoSignatories: 'Bis zu {count} {type}',

  // Feature access labels
  companyPlansAccessBulkTask: 'Zugang Zu Massenaufgaben',
  companyPlansVerifyContracts: 'Verträge Überprüfen',
  companyPlansStorageType: 'Speichertyp ({storageTypes})',
  settingsTitle: 'Einstellungen',
  settingsLanguageCardTitle: 'Spracheinstellungen',

  // Language selection
  settingsSelectLanguage: 'Sprache Auswählen',
  settingsSelectLanguageDescription: 'Wählen Sie Ihre bevorzugte Sprache für die Anwendungsoberfläche',
  settingsSelectLanguagePlaceholder: 'Sprache auswählen',

  // Language names
  settingsLanguageEnglish: 'English',
  settingsLanguageGerman: 'Deutsch',
  settingsLanguageFrench: 'Français',

  // Current selection
  settingsCurrentSelection: 'Aktuelle Auswahl',

  // Action buttons
  settingsSaveChanges: 'Änderungen Speichern',
  settingsResetToDefault: 'Auf Standard Zurücksetzen',

  // Messages
  settingsLanguageSaveSuccess: "Sprache erfolgreich geändert!",
  explore: 'Entdecken',
  esignservice: 'E-Signatur-Dienste',
  connected: 'Verbunden',
  weeks: 'Wochen',
  days: 'Tage',
  hours: 'Stunden',
  minutes: 'Minuten',
  seconds: 'Sekunden',
  count: 'Anzahl',
  type: 'Typ',
  submit: 'Absenden',
  cancel: 'Abbrechen',
  select:"Auswählen",
  duration:"Dauer",
  year:"Jahr",
  month:"Monat",
  day:"Tag",
  from:"Von",
  to:"Bis",
  custom:"Benutzerdef",
  digit_is_required:"Ziffer ist erforderlich",
  setcronjobduration:"Dauer des Cron-Jobs festlegen",
  set_duration:"Dauer festlegen",
  please_enter_a_valid_limit:"Bitte ein gültiges Limit eingeben",
  enter_digit:"Ziffer eingeben",
  storage:"Speicher",
  obligation_management:"Verpflichtungsverwaltung",
  filter:"Filter",
  grid_view:"Rasteransicht",
  list_view:"Listenansicht",
  view:"Ansicht",
  vendor_view:"Lieferantenansicht",
  details:"Details",
  archive:"Archiv",
  contract_family:"Vertragsfamilie",
  addendums:"Nachträge",
  obligations:"Verpflichtungen",
  basic_details:"Grunddaten",
  contract_id:"Vertrags-ID",
  counterparty_name:"Name der Gegenpartei",
  counterparty_email:"E-Mail der Gegenpartei",
  party_details:"Parteiendetails",
  add:"Hinzufügen",
  no_addendum_are_available:"Kein Nachtrag verfügbar",
  view_more:"Mehr anzeigen",
  overall_status:"Gesamtstatus",
  company:"Unternehmen",
  no_obligations_are_available:"Keine Verpflichtungen verfügbar",
  contract_family:"Vertragsfamilie",
  latest:"Neueste",
  contract_management:"Vertragsmanagement",
  your_10_most_recent_notifications:"Ihre 10 neuesten Benachrichtigungen",
  view_all:"Alle anzeigen",
  notifications:"Benachrichtigungen",
  dashboard:"Dashboard",
  artifact_status:"Artefaktstatus",
  contract_types_count:"Vertragstypenanzahl",
  contract_status:"Vertragsstatus",
  monthly_contract:"Monatlicher Vertrag",
  contract_monthly_count:"Monatliche Vertragsanzahl",
  historical:"Historisch",
  historical:"Historisch",
  historical_contract_status:"Status historischer Verträge",
  graph:"Grafik",
  contract_graph:"Vertragsgrafik",
  staff_status:"Mitarbeiterstatus",
  tasks:"Aufgaben",
  Workflows:"Workflows",
  contents:"Inhalte",
  signature:"Signatur",
  terminated:'Beendet',
  status:"Status",
  contract_from:"Vertrag von",
  filter:"Filter",
  normal_contracts:"Normale Verträge",
  historical_contracts:"Historische Verträge",
  analyse_risk_with_ai:"Risikoanalyse",
  create_linkage:"Verknüpfung erstellen",
  add_obligations:"Verpflichtungen hinzufügen",
  restructure:"Umstrukturieren",
  linkage:"Verknüpfung",
  task_no: "Aufgaben-Nr.",
  table_search_placeholder: "Suchen...",
  table_filter_ok: "OK",
  table_filter_reset: "Zurücksetzen",
  table_filter_title: "Filter",
  table_no_data:"Keine Daten",
  table_pagination_items_per_page:"/ Seite",
  table_pagination_show_total:"{range0}-{range1} von {total} Einträgen",
  workflow_suggestion: "Workflow-Vorschlag",
additional_notes: "Zusätzliche Notizen",
enter_any_extra_information_here: "Geben Sie hier zusätzliche Informationen ein",
value: "Wert",
contract_value: "Vertragswert",
which_type_of_department_is_used_for: "Für welche Art von Abteilung wird dies verwendet?",
additional_information: "Zusätzliche Informationen",
question: "Fragen",
task_information: "Aufgabeninformationen",
no_workflow_found: "Kein Workflow gefunden",
reviewandconfirm: "Überprüfen & Bestätigen",
review_your_task: "Überprüfen Sie Ihre Aufgabe",
priority: "Priorität",
task_startdate: "Startdatum der Aufgabe",
task_enddate: "Enddatum der Aufgabe",
task_description: "Aufgabenbeschreibung",
select_files: "Dateien auswählen",
clear_files: "Dateien löschen",
historical_contract_limit_exceeded: "Historisches Vertragslimit überschritten",
upload_record: "Datensatz hochladen",
download_sample_contracts: "Beispielverträge herunterladen",
dont_have_handy_contracts_text: "Haben Sie Ihre Verträge nicht zur Hand? Versuchen Sie, unsere Beispielverträge zu importieren.",
ai_smart_import_coming_soon: "KI-Smart Import (Bald verfügbar)",
import_text_without_ai: "Laden Sie Dateien hoch, ohne KI zur Datenerkennung zu verwenden. KI wird genutzt, um Dokumente per OCR zu verarbeiten und erweiterte Suche zu ermöglichen. Sie können die Daten nach dem Hochladen manuell taggen.",
add_more: "Mehr hinzufügen",
selected: "Ausgewählt",
drop_file_here: "Dateien hier ablegen",
browse_files: "Dateien durchsuchen",
files: "Dateien",
or: "Oder",
import_from: "Importieren von",
my_device: "Mein Gerät",
drive: "Drive",
dropbox: "Dropbox",
onedrive: "OneDrive",
connect_to_google_drive: "Mit Google Drive verbinden",
open_file_picker: "Dateiauswahl öffnen",
ready: "Bereit",
empty: "Leer",
oversized: "Zu groß",
note: "Hinweis",
do_not_upload_scanned_pdf: "Keine gescannten PDFs hochladen",
supports_files_under: "Unterstützt Dateien unter",
validfile: "Gültige Datei",
invalidfile: "Ungültige Datei",
import_from_google_drive: "Aus Google Drive importieren",
smart_import: "Intelligenter Import",
save_time_by_using: "Sparen Sie Zeit mit",
smart_import_extra_text: "Modellen, um Text zu scannen und automatisch wichtige Daten während des Uploads zu erkennen und zu taggen. Datensätze sind sofort durchsuchbar und filterbar",
export: "Exportieren",
create_with: "Erstellen mit",
admin: "Administrator",
select_content_from_library: "Inhalt aus der Bibliothek auswählen",
role_fields: "Rollenfelder",
custom_fields: "Benutzerdefinierte Felder",
company_fields: "Unternehmensfelder",
counterparty_fields: "Gegenparteifelder",
contract_fields: "Vertragsfelder",
default_fields: "Standardfelder",
help_box: "Hilfefeld",
for_contract_fields: "für Vertragsfelder",
for_role_fields: "für Rollenfelder",
use: "Verwenden",
sort_by_a_z: "Von A bis Z sortieren",
sort_by_z_a: "Von Z bis A sortieren",
sort_by_created_at: "Nach Erstellungsdatum sortieren",
sort_by_updated_at: "Nach Aktualisierungsdatum sortieren",
default: "Standard",
add_field: "Feld hinzufügen",
add: "Hinzufügen",
import_addendum: "Nachtrag importieren",
cancel: "Abbrechen",
import: "Importieren",
upload_pdf_only: "Bitte nur PDF-Dateien hochladen!",
file_size_limit: "Die Dateigröße muss kleiner als 10 MB sein!",
file_selected_successfully: "{filename} erfolgreich ausgewählt!",
file_removed_successfully: "Datei erfolgreich entfernt!",
upload_pdf_first: "Bitte laden Sie zuerst eine PDF-Datei hoch",
click_or_drag_file_to_upload: "Klicken oder ziehen Sie eine Datei zum Hochladen",
support_pdf_max_size: "Unterstützt nur PDF-Dateien • Maximale Größe: 10 MB",
file_ready_to_submit: "Datei ausgewählt und bereit zum Hochladen",
preview: "Vorschau",
remove: "Entfernen",
click_or_drag_to_replace_file: "Klicken oder ziehen Sie, um die Datei zu ersetzen",
weekly: "Wöchentlich",
monthly: "Monatlich",
quarterly: "Vierteljährlich",
yearly: "Jährlich",
daily: "Täglich",
obligation_no: "Verpflichtung Nr.",
view_obligation_of: "Verpflichtungen von anzeigen",
contract_clause: "Vertragsklausel",
currently_you_have_no_obligation_for_this_task: "Derzeit haben Sie keine Verpflichtung für diese Aufgabe",
due_date: "Fälligkeitsdatum",
expiry: "Ablauf",
waiting: "Wartend",
accepted: "Akzeptiert",
rejected: "Abgelehnt",
attached_documents: "Angehängte Dokumente",
attachments: "Anhänge",
dragger_upload_text: "Klicken oder Datei hierher ziehen, um sie hochzuladen",
dragger_upload_hint: "Unterstützte Dateiformate: PDF, PNG, JPG. Bitte laden Sie eine Datei in einem dieser Formate hoch.",
uploading: "Wird hochgeladen",
descriprion_rule: "Bitte geben Sie eine gültige Beschreibung ein",
add_documents: "Dokumente hinzufügen",
enter_your: "Geben Sie Ihr",
contract_duration_rule: "Bitte wählen Sie die Vertragsdauer",
contract_expiry_rule: "Bitte fügen Sie das Vertragsablaufdatum hinzu",
click_to_upload: "Zum Hochladen klicken",
please_enter: "Bitte eingeben",
phone_rule_: "Telefonnummer muss 8 - 14 Ziffern lang sein",
view_form: "Formular anzeigen",
fill_form: "Formular ausfüllen",
file_uploaded_successfully: "Datei erfolgreich hochgeladen",
file_uploaded_failed: "Datei-Upload fehlgeschlagen",
file_supporting_message: "Nur PDF-, JPG-, JPEG- und PNG-Dateien sind erlaubt!",
years: "Jahre",
months: "Monate",
choose_content: "Inhalt auswählen",
add_obligation: "Verpflichtung hinzufügen",
add_approver_rule: "Bitte eine Genehmigung hinzufügen",
strategy_rule: "Wählen Sie mindestens zwei Strategien",
integration: "Integration",
eSign: "E-Signatur",
back_to_integration: "Zur Integration zurück",
unlink_account: "Konto trennen",
link_account: "Konto verknüpfen",
connected: "Verbunden",
not_connected: "Nicht verbunden",
name: "Name",
email: "E-Mail",
integration_status: "Integrationsstatus",
connected_at: "Verbunden am",
list_View: "Listenansicht",
approval_in_progress: "Genehmigung läuft",
approved: "Genehmigt",
signature_inprogress: "Unterschrift läuft",
update_accepted: "Aktualisierung akzeptiert",
update_rejected: "Aktualisierung abgelehnt",
update_completed: "Aktualisierung abgeschlossen",
aborted: "Abgebrochen",
internal_review: "Interne Überprüfung",
review_completed: "Überprüfung abgeschlossen",
reviewed: "Überprüft",
upload_xlsx_file: "XLSX-Datei hochladen",
supportive_format_note: "Unterstütztes Dateiformat ist XLSX",
upload_format_tooltip: "Die hochgeladene Datei muss im XLSX-Format vorliegen",
update_obligation_form: "Verpflichtungsformular aktualisieren",
number: "Nummer (123...)",
text: "Text (Abc...)",
textarea: "Textbereich",
decimal: "Dezimal",
radio: "Optionsfeld",
checkbox: "Kontrollkästchen",
dropdown: "Dropdown-Liste",
datepicker: "Datumsauswahl",
 permission: "Berechtigung",
  financial_limit_rule: "Bitte geben Sie das finanzielle Limit ein",
  correct_email_warning: "Bitte geben Sie die korrekte E-Mail-Adresse ein",
  input_text_validation_message: "Nur Buchstaben, Zahlen und Leerzeichen sind erlaubt",
  enter_valid_name: "Geben Sie einen gültigen Namen ein",
  enter_valid_description: "Geben Sie eine gültige Beschreibung ein",
  workflow_created_successfully: "Workflow erfolgreich erstellt!",
  workflow_success_subtitle: "Möchten Sie die Aufgabe jetzt oder später erstellen?",
  later: "Später",
  go_to_task: "Zur Aufgabe gehen",
  assign_now: "Jetzt zuweisen",
  pagination_showTotal: "{start}-{end} von {total} Einträgen",
  on: "Ein",
    off: "Aus",
    text_editor: "Texteditor",
    unknown: "Unbekannt",
    enter_defination: "Definition eingeben",
    definition: "Definition",
    definition_rule: "Bitte geben Sie eine Definition ein",
    enter_property: "Eigenschaft eingeben",
    property_key: "Eigenschaftsschlüssel",
    property_key_rule: "Bitte geben Sie einen Eigenschaftsschlüssel ein",
     create_new_fields: "Neues Feld erstellen",
    update_field: "Feld aktualisieren",
    field_name: "Feldname",
    field_rule: "Bitte geben Sie den Feldnamen ein",
    field_placeholder: "Feldnamen eingeben",
    select_datatype_rule: "Bitte wählen Sie einen Datentyp aus",
     terminate_confirmation: "Sind Sie sicher, dass Sie diesen Vertrag kündigen möchten?",
    ai_analysis_failed: "KI-Analyse fehlgeschlagen",
    day_s: "Tag(e)",
    Parent: "Elternteil",
    Child: "Kind",
    ADDENDUM: "NACHTRAG",
    no_data_found: "Keine Daten gefunden",
    assigned: "Zugewiesen",
    signed: "Unterzeichnet",
    please_select_at_least_one: "Bitte wählen Sie mindestens eine Option aus",
lifecycle_rule_text:"Bitte füllen Sie die Felder der Lebenszyklusdetails aus",
extra_rule_text:"Bitte füllen Sie die Felder der zusätzlichen Details aus",
label_changed_successfully:"Label wurde erfolgreich geändert",
model:"Modell",
edit_prompt:"Eingabeaufforderung bearbeiten",
fill_with_ai:"Mit KI ausfüllen",
lifecycle_detail:"Lebenszyklusdetails",
parent_contract:"Übergeordneter Vertrag",
list_View:"Listenansicht",
contract_type_rule:"Vertragstyp ist erforderlich",
phone_valid_rule:"Bitte geben Sie eine gültige Telefonnummer ein",
enter: "Eingeben",
  task_no: "Aufgaben-Nr.",
  contract: "Vertrag",
  status: "Status",
  assigned: "Zugewiesen",
  completed: "Abgeschlossen",
  unassigned: "Nicht zugewiesen",
  duplicate: "Duplikat",
  duplicate_of: "Duplikat von",
  assigned_to: "Zugewiesen an",
  assigned_date: "Zuweisungsdatum",
  submission_date: "Einreichungsdatum",
  actions: "Aktionen",
  view: "Ansehen",
  edit: "Bearbeiten",
  assign: "Zuweisen",
  reassign: "Neu zuweisen",
  imported_on: "Importiert am",
  remove_duplicates: "Duplikate entfernen",
  no_missing_contract: "Kein fehlender Vertrag gefunden",
  no_missing_contract_found: "Kein fehlender Vertrag gefunden",
  missing_contract: "Fehlender Vertrag",
  find_missing_contract: "Fehlenden Vertrag finden",
  general_ai_prompt: "Allgemeine KI-Eingabe",
  upload_info: "Informationen hochladen",
  bulk_reassign: "Massen-Neuzuweisung",
  bulk_assign: "Massen-Zuweisung",
  assign_to_legal_associate: "Einem juristischen Mitarbeiter zuweisen",
  total: "Gesamt",
  all: "Alle",
  search: "Suchen...",
  filter: "Filtern",
  no_contracts: "Keine Verträge",
  ai_processing: "KI-Verarbeitung",
  finding_missing_contracts: "Fehlende Verträge werden gesucht...",
   imported: "Importiert",
  duplicate: "Duplikat",
  delete_duplicates: "Duplikate löschen",
  delete_duplicate_records: "Doppelte Einträge löschen",
  delete_duplicates_confirmation: "Möchten Sie wirklich {count} doppelte(n) Eintrag/Einträge löschen?",
  cancel: "Abbrechen",
  found_duplicates_message: "Wir haben Duplikate für {count} Datensatz{count, plural, one {} other {e}} gefunden. Wir können Ihnen helfen, die Duplikate zu löschen und die Originale zu behalten.",
   ai_context_prompt: "KI-Kontextaufforderung",
  please_input_ai_prompt: "Bitte geben Sie eine KI-Aufforderung ein!",
  enter_detailed_prompt_for_ai_analysis: "Geben Sie eine detaillierte Aufforderung für die KI-Analyse ein",
  delete_duplicate_records: "Doppelte Einträge löschen",
  delete_duplicates_confirmation: "Möchten Sie wirklich {count} doppelte(n) Eintrag/Einträge löschen?",
  found_duplicates_message: "Wir haben Duplikate für {count} Datensatz{count, plural, one {} other {e}} gefunden. Wir können Ihnen helfen, die Duplikate zu löschen und die Originale zu behalten.",
  ai_preview: "KI-Vorschau",
  pdf_loaded_success: "Vertrags-PDF erfolgreich geladen",
  pdf_loading_error: "Fehler beim Laden der PDF. Bitte versuchen Sie es erneut.",
  loading_pdf: "PDF wird geladen...",
  failed_to_load_pdf: "PDF konnte nicht geladen werden",
  ai_suggestions: "KI-Vorschläge",
  show_highlights: "Hervorhebungen anzeigen",
  hide_all: "Alle ausblenden",
  side_all: "Alle nebeneinander",
  page: "Seite",
  copyright: "Urheberrecht © {startYear}-{endYear}. Alle Rechte vorbehalten.",
   select_content_rule: "Bitte Inhalt auswählen",
   review_and_send: "Überprüfen und senden",
  reviewer: "Prüfer",
  parties: "Parteien",
  new_version_available_review: "Es ist eine neue Version verfügbar. Bitte überprüfen Sie diese",
  review: "Überprüfen",
  created_by: "Erstellt von",
  on: "am",
  collab: "Zusammenarbeit",
  edit: "Bearbeiten",
  more: "Mehr",
  email: "E-Mail",
  complete_review: "Überprüfung abschließen",
  edit_info: "Informationen bearbeiten",
  back: "Zurück",
  dept: "Abteilung",
  company: "Unternehmen",
  signed: "Unterschrieben",
  approved: "Genehmigt",
  waiting: "Warten",
  pending: "Ausstehend",
    service_level_agrrement: "Service-Level-Vereinbarung",
  select_obligation_template: "Obligationsvorlage auswählen",
  please_select_obligation_template: "Bitte Obligationsvorlage auswählen",
  non_collab: "Nicht kollaborativ",

collab_active: "Kollaborativer Modus ist aktiv",
collab_inactive: "Kollaborativer Modus ist inaktiv",
collaborative: "Kollaborativ",
missing_required_fields: "Fehlende {count} Pflichtfelder",

approve_and_sign: "Genehmigen und unterschreiben",
need_assistance: "Brauchen Sie Hilfe? Besuchen Sie unser",
help_center: "Hilfezentrum",
or_email: "oder E-Mail",
no_activities: "Keine Aktivitäten",
counterparty_information: "Informationen zur Gegenpartei",
counterparty_select_rule: "Bitte wählen Sie eine Gegenpartei aus",
invite_via_email: "Per E-Mail einladen",
vendor_limit_exceeded: "Lieferantenlimit gemäß Ihrem Plan überschritten. Bitte ändern Sie den Plan nach Bedarf",
change_expiry_label: "Möchten Sie das Ablaufdatum ändern?",
contract_information: "Vertragsinformationen",
company_information: "Unternehmensinformationen",
reviewer_information: "Prüferinformationen",
reviewer_select_rule: "Bitte wählen Sie einen Prüfer aus",
add_new: "Neu hinzufügen",
  email_document: "E-Mail-Dokument",
  cancel: "Abbrechen",
  send: "Senden",
  to: "An",
  cc: "Cc",
  subject: "Betreff",
  draft_contract: "Vertragsentwurf",
  please_review: "Bitte überprüfen",
  dear: "Sehr geehrte/r",
  reviewer: "Prüfer",
  signatory: "Unterzeichner",
  you_have_been_added_as: "Sie wurden hinzugefügt als",
  in_the_following_contract: "im folgenden Vertrag.",
  contract_name: "Vertragsname",
  please_find_the_contract_attached: "Bitte finden Sie den Vertrag im Anhang dieser E-Mail und überprüfen Sie die Vertragsklauseln. Wenn Änderungen erforderlich sind, antworten Sie bitte an die Firmen-E-Mail",
  best_regards: "Mit freundlichen Grüßen,",
  team: "Team",
  replies_appear_in_activity: "Antworten auf diese E-Mail erscheinen automatisch im Aktivitätsfeed",
  processing: "Verarbeitung",
parameterizing_field_text: "Wir parameterisieren Felder im Inhalt",
if: "Wenn",
wait_moment: "Bitte warten Sie einen Moment",
delete_comment_title: "Sind Sie sicher, dass Sie diesen Kommentar löschen möchten?",
contract_success_message: "Glückwunsch! Ihr Vertrag wurde erfolgreich erstellt",
go_to_my_contracts: "Zu meinen Verträgen gehen",
obligation_expiry: "Ablauf der Verpflichtung",
add_comment: "Kommentar hinzufügen",
reviewer_count: "Anzahl der Gutachter",
signatory_count: "Anzahl der Unterzeichner",
sla_weekly_review: "Wöchentliche Überprüfung",
sla_priority_standard: "Standard-Priorität",
sla_weekly_description: "Diese Verpflichtung erfordert eine wöchentliche Überprüfung.",

sla_monthly_check: "Monatliche Kontrolle",
sla_priority_routine: "Routine-Priorität",
sla_monthly_description: "Diese Verpflichtung erfordert eine monatliche Kontrolle.",

sla_quarterly_report: "Vierteljährlicher Bericht",
sla_priority_important: "Wichtige Priorität",
sla_quarterly_description: "Diese Verpflichtung erfordert einen vierteljährlichen Bericht.",

sla_annual_review: "Jährliche Überprüfung",
sla_priority_strategic: "Strategische Priorität",
sla_annual_description: "Diese Verpflichtung erfordert eine jährliche Überprüfung.",

sla_daily_monitoring: "Tägliche Überwachung",
sla_priority_critical: "Kritische Priorität",
sla_daily_description: "Diese Verpflichtung erfordert eine tägliche Überwachung.",

company_label: "Unternehmen",
counterparty_label: "Gegenpartei",

this_obligation: "diese Verpflichtung",
remove_confirmation_title: "Sind Sie sicher, dass Sie {name} entfernen möchten?",
remove_obligation_warning: "Das Entfernen dieser Verpflichtung kann nicht rückgängig gemacht werden.",
remove: "Entfernen",
cancel: "Abbrechen",
removed_successfully: "erfolgreich entfernt",
edit: "Bearbeiten",

unnamed_obligation: "Unbenannte Verpflichtung",
new_label: "Neu",
no_description_available: "Keine Beschreibung verfügbar",

obligations_ready_to_add: "Verpflichtungen bereit zum Hinzufügen",
please_add_obligation_before_submit: "Bitte fügen Sie mindestens eine Verpflichtung hinzu, bevor Sie fortfahren.",
add_obligation: "Verpflichtung hinzufügen",
contract_obligations_management: "Vertragsverpflichtungen Verwaltung",
adding_obligations_to_contract: "Verpflichtungen zum Vertrag {name} hinzufügen",
document: "Dokument",
contract_content: "Vertragsinhalt",
obligations_library: "Verpflichtungsbibliothek",
add_new: "Neu hinzufügen",
no_obligations_added_yet: "Es wurden noch keine Verpflichtungen hinzugefügt.",
click_add_new_to_create: "Klicken Sie auf 'Neu hinzufügen', um Verpflichtungen zu erstellen.",
 assign_obligation: "Verpflichtung zuweisen",
    please_select_one: "Bitte wählen Sie eine aus",
    enter_contract_clause: "Vertragsklausel eingeben",
    enter_clause: "Klausel eingeben",
    select_obligation: "Verpflichtung auswählen",
    already_used: "Bereits verwendet",
    obligation_template: "Verpflichtungsvorlage",
     lifecycle_info: "Lebenszyklus-Info",
    tag: "Tag",
    describe_why_field_is_use_for: "Beschreiben Sie, wofür das Feld verwendet wird?",
    option_duplicate_rule: "Optionen dürfen nicht doppelt sein",

ongoing_review: "Laufende Überprüfung",
 workflow_required_rule: "Bitte geben Sie einen Workflownamen ein",
   assign_contract: "Vertrag zuweisen",
  reassign_contract: "Vertrag neu zuweisen",
  assign_contracts_text:
    "{count} Vertrag/Verträge einem Rechtsberater zuweisen",
  reassign_contracts_text:
    "{count} Vertrag/Verträge einem Rechtsberater neu zuweisen",
  select_associate_rule: "Bitte wählen Sie einen Rechtsberater aus",
  select_legal_associate: "Rechtsberater auswählen",
  choose_associate: "Wählen Sie einen Rechtsberater",
  none: "Keiner",
  confirm_unassign: "Sind Sie sicher, dass Sie diesen Vertrag aufheben möchten?",
  confirm_assign_contracts:
    "Sind Sie sicher, dass Sie {count} Vertrag/Verträge diesem Rechtsberater zuweisen möchten?",
  yes: "Ja",
  no: "Nein",
    bulk_assign_modal_title: "Massenweise Zuweisung an Rechtsanwälte",
    select_assignment_method: "Zuweisungsmethode auswählen",
    document_range: "Dokumentenbereich",
    percentage_range: "Prozentsatzbereich",
    range: "Bereich",
    from_document: "Von Dokument",
    to_document: "Bis Dokument",
    assign_to: "Zuweisen an",
    reassign_to: "Neu zuweisen an",
    required: "Erforderlich",
    to_doc_greater: "Bis Dokument muss größer als Von Dokument sein",
    ranges_overlap: "Bereiche dürfen sich nicht überschneiden",
    create_range: "Bereich erstellen",
    cancel: "Abbrechen",
    assign: "Zuweisen",
    reassign: "Neu zuweisen",
    warning_all_assigned: "Alle Dokumente sind bereits zugewiesen",
    error_add_range: "Fehler beim Hinzufügen des neuen Bereichs",
    please_fill_required: "Bitte füllen Sie alle Pflichtfelder aus",
    check_all: "Alle auswählen",
    verify_text_rule: "Überprüfen Sie die Details, indem Sie das Kontrollkästchen anklicken",
    input_must_50: "Die Eingabe darf höchstens 50 Zeichen lang sein.",
    new_chat: "Neuer Chat",
    ai_powered: "KI-gestützt",
    ask: "Fragen",
    type_a_message: "Geben Sie eine Nachricht ein...",
    please_wait: "Bitte warten...",
    versions: "Versionen",
  info: "Info",
  compare: "Vergleichen",
  active: "Aktiv",
  no_version_yet: "Noch keine Version",
  with: "Mit",
  task_details: "Aufgabendetails",
  task_name: "Aufgabenname",
  description: "Beschreibung",
  startdate: "Startdatum",
  enddate: "Enddatum",
  status: "Status",
  version: "Version",
  created_by: "Erstellt von",
  submit: "Einreichen",
  today: "Heute",
  tomorrow: "Morgen",
  yesterday: "Gestern",
   filter_contracts: "Verträge filtern",
  legal_associate: "Juristische Mitarbeiter",
  select_legal_associate: "Rechtsberater auswählen",
  clear_filter: "Filter löschen",
  apply_filter: "Filter anwenden",
   upload_info: "Information hochladen",
  export_record: "Datensatz exportieren",
  close: "Schließen",
  upload: "Hochladen",
  click_or_drag_file: "Klicken oder Datei hierher ziehen, um sie hochzuladen",
  upload_hint: "Unterstützt Einzel- oder Massen-Upload. Das Hochladen von Firmendaten oder anderen verbotenen Dateien ist strengstens untersagt.",
  file_selected: "Datei ausgewählt",
  file_uploaded_successfully: "Datei erfolgreich hochgeladen.",
  file_upload_failed: "Datei-Upload fehlgeschlagen.",
  only_xlsx_allowed: "Es können nur .xlsx-Dateien hochgeladen werden!",
  error_reading_excel: "Fehler beim Lesen der Excel-Datei. Bitte überprüfen Sie das Format.",
   analysis_report: "Analysebericht",
  ai_analysing_text: "KI analysiert das Dokument",
  complete_review_document: "Überprüfungsdokument abschließen",
  cancel: "Abbrechen",
  upload: "Hochladen",
  attachments: "Anhang/Anhänge",
  click_to_upload: "Klicken zum Hochladen",
  only_doc_allowed: "Nur .doc- und .docx-Dateien sind erlaubt!",
   delete_comment: "Kommentar löschen",
   obligations_label_for_attach: "Möchten Sie Verpflichtungen für diesen Workflow anhängen?",
 content_template: "Inhaltsvorlagen",
  task_approved: "Aufgabe genehmigt",
  out_for_signature: "Zur Unterschrift versendet",
  go_back: "Zurück",







}
